var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.99985 7.50003C6.73724 7.50049 6.47713 7.44904 6.23446 7.34865C5.9918 7.24825 5.77137 7.10089 5.58585 6.91503L0.292847 1.62103L1.70685 0.207031L6.99985 5.50003L12.2928 0.207031L13.7068 1.62103L8.41385 6.91403C8.2284 7.10007 8.00801 7.24762 7.76535 7.34819C7.52268 7.44875 7.26253 7.50036 6.99985 7.50003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ff03b3dcfe58e479eaf88206a2039591.svg";
export { ForwardRef as ReactComponent };